window.EG_HELP_CENTRE_DISPLAY = {
  setActiveHelpBlock: function (helpBlockLinks, cat) {
    if (!helpBlockLinks || !helpBlockLinks.length) return;

    helpBlockLinks.forEach(function (link) {
      link.classList.toggle(
        'nav-blocks-checked',
        link.getAttribute('data-help-category') === cat
      );
    });
  },

  setFaqResultsLabel: function (faqResultsLabel, cat) {
    if (!faqResultsLabel) return;

    var labelMap = {
      delivery: 'Common delivery questions',
      returns: 'Common returns questions',
      orders: 'Common ordering questions',
      payment: 'Common payment questions',
      warranty: 'Common warranty questions',
      business: 'Common business questions'
    };

    faqResultsLabel.textContent = labelMap[cat] || 'Most common questions';
  },

  showHelpPagePanel: function (helpPageContent, cat) {
    if (!helpPageContent) return;

    helpPageContent.classList.remove('cf-hidden');

    helpPageContent.querySelectorAll('.cf-help-page-panel').forEach(function (panel) {
      panel.classList.toggle(
        'cf-hidden',
        panel.getAttribute('data-page-content') !== cat
      );
    });
  },

  hideHelpPagePanels: function (helpPageContent) {
    if (!helpPageContent) return;

    helpPageContent.classList.add('cf-hidden');

    helpPageContent.querySelectorAll('.cf-help-page-panel').forEach(function (panel) {
      panel.classList.add('cf-hidden');
    });
  }
};